import _Text from "./konva/_Text";

export default class ClientConfig{
    constructor(config){
        this.config = config
        this.hideContentOverprint();
        this.configureLayers();
        this.disableDraggableOnGroups();
        this.hideFrames();
    }

    configureLayers(){
        let layers = this.config.stage.getLayers();
        let tempLayers = Object.assign([], layers);
        for(let layer of tempLayers){
            if(layer.isVisible()){
                this.loadAdditionals(layer);
            }else{
                layers.forEach((value, index) => {
                    if(layer === value){
                        value.remove();
                    }
                })
            }
        }
    }

    hideFrames(){
        let layers = this.config.stage.getLayers();
        for(let layer of layers){
            let group = layer.findOne('Group');
            let toHide = group?.getChildren((child) => {
                return child.getAttr('name') != 'content';
            });

            if(toHide){
                for(let child of toHide){
                    child.hide();
                }
            }
        }
    }

    disableDraggableOnGroups(){
        this.config.stage.find('Group').forEach(group => {
            group.draggable(false);
        })
    }
    
    hideContentOverprint(){
        this.config.stage.find('.content_overprint').forEach(element => {
            element.hide();
        })
    }

    loadAdditionals(layer){
        let objectType = layer.getAttr('object_type');
        let content  = layer.findOne('.content');
        this.overrideAttributes(objectType, content);
    }

    overrideAttributes(objectType, content){
        if(objectType === 'product'){
            if(this.config.project.product_layer_image)
                content.setAttr('image_src', this.config.project.product_layer_image);
            if(this.config.project.product_layer_rotate)
                content.setAttr('image_rotate', this.config.project.product_layer_rotate);
            else
                content.setAttr('image_rotate', 0);
        }
        
        if(['image', 'ellipse', 'text_normal'].includes(objectType)){
            if(content.getAttr('texture_src') && this.config.project.product_layer_texture){
                content.setAttr('texture_src', this.config.project.product_layer_texture);
            }
    
            if(objectType === 'image' && content.getAttr('motiv_group') && this.config.project.default_motiv_src && content.getAttr('motiv_group') != '0'){
                content.setAttr('texture_src', this.config.project.product_layer_texture);
                content.setAttr('image_src', this.config.project.default_motiv_src);
                content.setAttr('default_motiv', this.config.project.default_motiv);
            }
        }
    }

}